import { Button, Input, Label } from "@heroui/react";
import { Icon } from "@iconify/react";

import { PickupTime } from "@/features/pickup-schedule/type.ts";

// Редактор слотов времени: добавление/удаление и правка value/displayTime.
export function TimesEditor({
  times,
  onChange,
}: {
  times: PickupTime[];
  onChange: (times: PickupTime[]) => void;
}) {
  const update = (index: number, patch: Partial<PickupTime>) => {
    const next = times.map((t, i) => (i === index ? { ...t, ...patch } : t));
    onChange(next);
  };

  const remove = (index: number) => {
    onChange(times.filter((_, i) => i !== index));
  };

  const add = () => {
    onChange([...times, { value: "", displayTime: "" }]);
  };

  return (
    <div className="flex flex-col gap-2">
      <Label>Слоты времени</Label>

      {times.map((time, index) => (
        <div key={index} className="flex flex-row items-end gap-2">
          <div className="flex flex-col gap-1">
            <span className="text-xs text-default-500">Значение (на сервер)</span>
            <Input
              placeholder="09:00"
              value={time.value}
              onChange={(e) => update(index, { value: e.target.value })}
            />
          </div>

          <div className="flex flex-col gap-1 flex-1">
            <span className="text-xs text-default-500">Подпись</span>
            <Input
              placeholder="09:00–12:00"
              value={time.displayTime}
              onChange={(e) => update(index, { displayTime: e.target.value })}
            />
          </div>

          <Button
            isIconOnly
            variant="danger-soft"
            onPress={() => remove(index)}
          >
            <Icon className="size-5" icon="solar:trash-bin-trash-bold-duotone" />
          </Button>
        </div>
      ))}

      <Button variant="ghost" onPress={add}>
        <Icon className="size-5" icon="ion:add" />
        Добавить время
      </Button>
    </div>
  );
}
